import { c as _c } from "react/compiler-runtime";
import { ContentCard, type ImageComponent } from "fansunited-sports-ui";
import { FillImage } from "@/components/ui/FillImage";
import type { PostGridProps } from "./types";

/**
 * Standard variant: Standard cards with title and image (grid view)
 */
export function PostGridStandard(t0) {
  const $ = _c(20);
  const {
    posts,
    title,
    formatDate,
    getImageUrl,
    className,
    columns,
    buildLink
  } = t0;
  let t1;
  if ($[0] !== columns) {
    t1 = () => {
      if (columns === 1) {
        return "grid-cols-1";
      }
      if (columns === 2) {
        return "grid-cols-2";
      }
      if (columns === 3) {
        return "grid-cols-3";
      }
      return "grid-cols-1 md:grid-cols-2 lg:grid-cols-3";
    };
    $[0] = columns;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getGridCols = t1;
  let t2;
  if ($[2] !== title) {
    t2 = title && <h2 className="text-2xl font-bold mb-6">{title}</h2>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `grid ${getGridCols()} gap-6`;
  let t4;
  if ($[4] !== buildLink || $[5] !== formatDate || $[6] !== getImageUrl || $[7] !== posts) {
    let t5;
    if ($[9] !== buildLink || $[10] !== formatDate || $[11] !== getImageUrl) {
      t5 = post => <ContentCard key={post.id} content={{
        id: String(post.id),
        type: post.type === "video" ? "video" : "article",
        link: buildLink(post),
        title: post.title,
        description: post.summary || "",
        image: {
          url: getImageUrl(post.heroImage) || "",
          alt: post.title
        },
        metadata: {
          time: formatDate(post.publishedAt)
        }
      }} variant="standard" ImageComponent={FillImage as ImageComponent} styles={{
        typography: {
          title: "text-lg font-semibold",
          description: "text-sm text-muted-foreground line-clamp-2"
        }
      }} />;
      $[9] = buildLink;
      $[10] = formatDate;
      $[11] = getImageUrl;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = posts.map(t5);
    $[4] = buildLink;
    $[5] = formatDate;
    $[6] = getImageUrl;
    $[7] = posts;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== className || $[17] !== t2 || $[18] !== t5) {
    t6 = <section className={className}>{t2}{t5}</section>;
    $[16] = className;
    $[17] = t2;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}